import { createAction } from 'redux-actions';

import { wrapFetch } from './endpoint';

export const getRestautantData = createAction('FETCH_RESTAURANT_DATA', async (lan, hotel) => {
	const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/${hotel}/restaurant`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	const reconstructedData = data.map(initData => ({
		id: initData.id,
		title: initData.title,
		category: initData.category.name,
		content: initData.intro,
		detail: {
			sections: initData.meta.map(meta => ({
				id: meta.id,
				title: meta.title,
				contents: meta.content.split('\n').map((content, index) => ({
					id: index,
					item: content,
				})),
			})),
		},
		images: initData.photos.map(photo => photo.url),
		thumbnail: initData.photos.map(photo => photo.thumb_url),
	}));

	return { data: reconstructedData };
});



// WEBPACK FOOTER //
// ./src/actions/restaurant.js